import { Button, Card, Col, DatePicker, Modal, Row, Select, Space, Table } from 'antd';
import dayjs from 'dayjs';
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import APIList from '../http/ApiList';
import { AppContext } from '../contexts/AppContext';

const StatisticsModal = (props: any) => {
  const { t } = useTranslation();
  const { color } = useContext(AppContext);
  const { showModal, setShowModal } = props;
  const [loading, setLoading] = useState(false);

  const [selectedDate, setSelectedDate] = useState(dayjs());
  const handleDateChange = (date) => {
    setSelectedDate(date);
  };
  const handleFilterBtnClick = () => {
    getTableData();
  };
  const filter = (
    <Space wrap>
      <DatePicker picker="month" style={{ width: 160 }} value={selectedDate} onChange={handleDateChange} />
      <Button type="primary" onClick={handleFilterBtnClick} loading={loading}>
        選択
      </Button>
    </Space>
  );

  const columns = [
    {
      title: 'Project',
      dataIndex: 'projectId',
      sorter: (a, b) => (a.projectId ?? '').localeCompare(b.projectId ?? ''),
    },
    {
      title: 'Project Plans',
      dataIndex: 'planName',
      sorter: (a, b) => (a.planName ?? '').localeCompare(b.planName ?? ''),
    },
    {
      title: 'User',
      dataIndex: 'createdBy',
      width: 300,
      sorter: (a, b) => (a.createdBy ?? '').localeCompare(b.createdBy ?? ''),
    },
    {
      title: 'Execution Time',
      dataIndex: 'executionTime',
      width: 160,
      render: (val) => dayjs(val).format('YYYY-MM-DD HH:mm:ss'),
      sorter: (a, b) => dayjs(a.executionTime).valueOf() - dayjs(b.executionTime).valueOf(),
      defaultSortOrder: 'ascend' as const,
    },
    {
      title: 'Optimization Steps',
      dataIndex: 'step',
      width: 140,
      render: (value) => <div style={{ textAlign: 'right' }}>{value?.toLocaleString()}</div>,
      sorter: (a, b) => (a.step ?? 0) - (b.step ?? 0),
    },
    {
      title: 'Billings(JPY)',
      dataIndex: 'billings',
      width: 120,
      render: (value) => <div style={{ textAlign: 'right' }}>{value?.toLocaleString()}</div>,
      sorter: (a, b) => (a.billings ?? 0) - (b.billings ?? 0),
    },
  ];

  const [pageData, setPageData] = useState({
    amount: 0,
    runs: 0,
    user: 0,
    detail: [],
  });
  const getTableData = () => {
    setLoading(true);
    APIList.getOptimizationJobs()
      .get({ date: selectedDate.format('YYYY-MM-DD') })
      .then((res) => {
        res.detail?.forEach((d) => (d.id = crypto.randomUUID()));
        setPageData(res);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    if (showModal) {
      getTableData();
    }
  }, [showModal]);

  return (
    <Modal
      maskClosable={false}
      open={showModal}
      width="90%"
      centered
      footer={null}
      styles={{ body: { paddingTop: 30 } }}
      onCancel={() => setShowModal(false)}
    >
      <Card
        title={t('aipskd.statistics.pageTitle')}
        className="list-card tree-table"
        styles={{
          header: { minHeight: 46, fontSize: 20, fontWeight: 900 },
        }}
        extra={filter}
      >
        <Row justify="space-between" gutter={16}>
          <Col span={8}>
            <Card title="Optimization" size="small">
              <div style={{ textAlign: 'center', fontSize: 20 }}>Monthly Optimization Runs</div>
              <div style={{ textAlign: 'center' }}>
                <span style={{ fontSize: 30, fontWeight: 600, color: color.primaryColor }}>{pageData.runs.toLocaleString()}</span> Runs
              </div>
            </Card>
          </Col>
          <Col span={8}>
            <Card title="Unique Users" size="small">
              <div style={{ textAlign: 'center', fontSize: 20 }}>Monthly Unique Users</div>
              <div style={{ textAlign: 'center' }}>
                <span style={{ fontSize: 30, fontWeight: 600, color: color.primaryColor }}>{pageData.user.toLocaleString()}</span> Users
              </div>
            </Card>
          </Col>
          <Col span={8}>
            <Card title="Billing Amount" size="small">
              <div style={{ textAlign: 'center', fontSize: 20 }}>Monthly Billing</div>
              <div style={{ textAlign: 'center' }}>
                <span style={{ fontSize: 30, fontWeight: 600, color: color.primaryColor }}>{pageData.amount.toLocaleString()}</span> JPY
              </div>
            </Card>
          </Col>
        </Row>
        <Card style={{ marginTop: 20 }}>
          <Table
            dataSource={pageData.detail}
            columns={columns}
            size="small"
            bordered
            pagination={false}
            loading={loading}
            rowKey={(row) => row.id}
            scroll={{ y: 360 }}
          />
        </Card>
      </Card>
    </Modal>
  );
};

export default StatisticsModal;
